import React from 'react';
import { CheckIcon } from 'lucide-react';
import { useOffer } from '../contexts/OfferContext';
import { offerConfig, urgencyConfig } from '../data/siteConfig';
import { useRemoteNumber } from '../hooks/useRemoteNumber';
export const UrgencySection = () => {
  const {
    secondsLeft,
    expired
  } = useOffer();
  const showEnded = expired && offerConfig.offerEndsInCheckout;
  const cupos = useRemoteNumber(urgencyConfig.cuposEndpoint, urgencyConfig.cuposDisponiblesHoy);
  const viewers = useRemoteNumber(urgencyConfig.activeViewersEndpoint, 0);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const cuposValue = Math.max(0, Math.min(cupos.value, urgencyConfig.totalCupos));
  const cuposPct = Math.round(cuposValue / urgencyConfig.totalCupos * 100);
  return <section id="precio-lanzamiento" className="bg-familia-dark border-t border-familia-darkBorder py-12 md:py-16 px-4 md:px-6" data-id="element-268" data-mp="1uu0s59kk5w40">
      <div className="max-w-3xl mx-auto text-center w-full" data-id="element-269" data-mp="1qurzk81984a1">
        <div className="max-w-xl mx-auto bg-familia-darkCard border-2 border-familia-darkBorder p-6 md:p-8 rounded-2xl" data-id="element-270" data-mp="2su6d7b51gjwe">
          <h2 className="text-white font-bold text-[26px] uppercase tracking-wide leading-snug mb-6" data-id="element-271" data-mp="2xtsqtlos425q">
            Oferta especial de hoy
          </h2>

          <p className="text-body text-familia-onDarkMuted mb-5" data-id="element-272" data-mp="37ikehhmt40au">
            Te reservamos este precio promocional por los próximos{' '}
            <span className="font-bold text-white" data-id="element-273" data-mp="3cglxk2k8fzmb">
              {offerConfig.reservationMinutes} minutos
            </span>
            :
          </p>

          {showEnded ? <div role="status" className="border-2 border-familia-urgent rounded-xl px-5 py-5 mb-6" data-id="element-274" data-mp="3libxjws6k6vp">
              <p className="text-familia-urgent font-bold text-2xl uppercase tracking-wider" data-id="element-275" data-mp="3qh6hj21vw1he">
                La oferta finalizó
              </p>
            </div> : <>
              <div className="flex justify-center items-start gap-3 sm:gap-4 mb-6" role="timer" aria-live="off" aria-label={`Quedan ${pad(minutes)} minutos y ${pad(seconds)} segundos`} data-id="element-276" data-mp="1r6f5q2ptsz04">
                {[{
              value: minutes,
              label: 'MINUTOS'
            }, {
              value: seconds,
              label: 'SEGUNDOS'
            }].map(unit => <div key={unit.label} className="bg-familia-dark border-2 border-familia-urgent/60 rounded-xl px-5 sm:px-7 py-3 sm:py-4 min-w-[100px] sm:min-w-[120px]" data-id="element-277" data-mp="1y1x3emtg0wgc">
                    <div className="font-mono text-familia-urgent text-4xl sm:text-5xl font-bold leading-none tabular-nums" data-id="element-278" data-mp="271bunohfpb1w">
                      {pad(unit.value)}
                    </div>
                    <div className="text-familia-onDarkMuted text-[12px] sm:text-[13px] font-bold uppercase tracking-widest mt-2" data-id="element-279" data-mp="2grdfm7ehqdcl">
                      {unit.label}
                    </div>
                  </div>)}
              </div>
            </>}

          <div className="border-t border-familia-darkBorder pt-5 mb-5 text-left" data-id="element-280" data-mp="2qqcitaghlgs7">
            <div className="flex items-baseline justify-between gap-3 mb-2" data-id="element-281" data-mp="2lrj3dchn3fpe">
              <span className="text-[14px] sm:text-[15px] font-semibold text-familia-onDarkMuted" data-id="element-282" data-mp="35bqc75ttma4b">
                Cupos con precio de lanzamiento hoy:
              </span>
              <span className="text-[15px] sm:text-[16px] font-bold text-familia-urgent whitespace-nowrap" data-id="element-283" data-mp="39bimpo2ryqcb">
                {cuposValue} de {urgencyConfig.totalCupos}
              </span>
            </div>
            <div className="w-full bg-familia-urgent/15 h-3 rounded-full overflow-hidden" role="progressbar" aria-valuemin={0} aria-valuemax={urgencyConfig.totalCupos} aria-valuenow={cuposValue} aria-label="Cupos con precio de lanzamiento disponibles hoy" data-id="element-284" data-mp="2loajdbowprcx">
              <div className="bg-familia-urgent h-full rounded-full transition-[width] duration-300 ease-out" style={{
              width: `${cuposPct}%`
            }} data-id="element-285" data-mp="2cp5l86h9c01a" />
            </div>
          </div>

          {viewers.isLive ? <div className="flex items-center justify-center gap-2" data-id="element-286" data-mp="22rho59w6igfy">
              <span className="w-2.5 h-2.5 bg-familia-urgent rounded-full animate-blink" aria-hidden="true" data-id="element-287" data-mp="27n6i8xpfj54v" />
              <span className="text-[15px] sm:text-[16px] text-familia-onDarkMuted" data-id="element-288" data-mp="3ayvrufg85iul">
                <span className="font-bold text-white" data-id="element-289" data-mp="361n5s3ryguo2">
                  {viewers.value} personas
                </span>{' '}
                están viendo esta página ahora
              </span>
            </div> : urgencyConfig.descargasEstaSemana === null ? null : <div className="flex items-center justify-center gap-2" data-id="element-290" data-mp="2rbfx2frr2q0k">
              <CheckIcon className="w-4 h-4 text-familia-checkDark shrink-0" strokeWidth={3} aria-hidden="true" data-id="element-291" data-mp="2rcqwy4i2rdme" />
              <span className="text-[15px] sm:text-[16px] text-familia-onDarkMuted" data-id="element-292" data-mp="2nc743d4jaw62">
                <span className="font-bold text-white" data-id="element-293" data-mp="2icu5jv4aw0nn">
                  {urgencyConfig.descargasEstaSemana} familias
                </span>{' '}
                lo descargaron esta semana
              </span>
            </div>}
        </div>
      </div>
    </section>;
};
function pad(n: number): string {
  return n.toString().padStart(2, '0');
}